import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";

interface IProps {
    closeLabel?: string;
    closeTestId?: string;
    onClose?: () => void;
    progress?: number | null;
    progressLabel?: string;
    progressTestId?: string;
}

export const ModalTopBar = (props: IProps) => {
    const {closeLabel, closeTestId, onClose, progress, progressLabel, progressTestId} = props;
    const progressValue = progress == null ? null : Math.min(100, Math.max(0, progress));

    return (
        <div className={topBarStyle} data-close={onClose ? "" : undefined}>
            {progressValue != null && (
                <div
                    aria-label={progressLabel}
                    aria-valuemax={100}
                    aria-valuemin={0}
                    aria-valuenow={progressValue}
                    className={progressTrackStyle}
                    data-testid={progressTestId}
                    role="progressbar"
                >
                    <div className={progressFillStyle} style={{width: `${progressValue}%`}} />
                </div>
            )}
            {onClose && (
                <button aria-label={closeLabel} className={closeButtonStyle} data-testid={closeTestId} onClick={onClose} type="button">
                    <CloseIcon size="2.4" />
                </button>
            )}
        </div>
    );
};

const topBarStyle = css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    height: "7.2rem",
    pl: 3,
    pr: 10,

    "&[data-close]": {
        pr: 2.5
    }
});

const progressTrackStyle = css({
    backgroundColor: "var(--colors-gray-300)",
    borderRadius: "10rem",
    flex: "1",
    height: "1rem",
    overflow: "hidden"
});

const progressFillStyle = css({
    backgroundColor: "var(--colors-secondary)",
    borderRadius: "10rem",
    height: "100%",
    transition: "width 220ms cubic-bezier(0.4, 0, 0.2, 1)"
});

const closeButtonStyle = css({
    background: "transparent",
    border: 0,
    cursor: "pointer",
    flexShrink: 0,
    marginLeft: "auto",
    p: 0
});
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";

interface IProps {
    closeLabel?: string;
    closeTestId?: string;
    onClose?: () => void;
    progress?: number | null;
    progressLabel?: string;
    progressTestId?: string;
}

export const ModalTopBar = (props: IProps) => {
    const {closeLabel, closeTestId, onClose, progress, progressLabel, progressTestId} = props;
    const progressValue = progress == null ? null : Math.min(100, Math.max(0, progress));

    return (
        <div className={topBarStyle} data-close={onClose ? "" : undefined}>
            {progressValue != null && (
                <div
                    aria-label={progressLabel}
                    aria-valuemax={100}
                    aria-valuemin={0}
                    aria-valuenow={progressValue}
                    className={progressTrackStyle}
                    data-testid={progressTestId}
                    role="progressbar"
                >
                    <div className={progressFillStyle} style={{width: `${progressValue}%`}} />
                </div>
            )}
            {onClose && (
                <button aria-label={closeLabel} className={closeButtonStyle} data-testid={closeTestId} onClick={onClose} type="button">
                    <CloseIcon size="2.4" />
                </button>
            )}
        </div>
    );
};

const topBarStyle = css({
    alignItems: "center",
    display: "flex",
    flexShrink: 0,
    height: "7.2rem",
    pl: 3,
    pr: 10,

    "&[data-close]": {
        pr: 2.5
    }
});

const progressTrackStyle = css({
    backgroundColor: "var(--colors-gray-300)",
    borderRadius: "10rem",
    flex: "1",
    height: "1rem",
    overflow: "hidden"
});

const progressFillStyle = css({
    backgroundColor: "var(--colors-secondary)",
    borderRadius: "10rem",
    height: "100%",
    transition: "width 220ms cubic-bezier(0.4, 0, 0.2, 1)"
});

const closeButtonStyle = css({
    background: "transparent",
    border: 0,
    cursor: "pointer",
    flexShrink: 0,
    marginLeft: "auto",
    p: 0
});
